import { BackgroundColors } from '@/@types/types';
import { UserUiDto } from '@/api';

export default {
  path: 'support',
  name: 'settings.support',
  meta: {
    requiresAuth: true,
    roles: [UserUiDto.role.ADMIN],
    breadCrumb: 'app.navigation-drawer.support',
    background: BackgroundColors.SECONDARY,
  },
  component: () => import('@/views/FrontendNextRouteView.vue'),
};
